import { render, staticRenderFns } from "./gj-textarea.vue?vue&type=template&id=17f4b796&scoped=true&"
import script from "./gj-textarea.vue?vue&type=script&lang=js&"
export * from "./gj-textarea.vue?vue&type=script&lang=js&"
import style0 from "./gj-textarea.vue?vue&type=style&index=0&id=17f4b796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f4b796",
  null
  
)

export default component.exports